import React from 'react'
// import ReactDOMServer from 'react-dom/server';
import { Button, Card, CardBody, Col, Row, Table } from 'reactstrap'
import './style.css'
import { MedialService } from 'utils/MediaService'
import Swal from 'sweetalert2'
import { FAILED_TO_DELETE_DATA, FAILTOSAVERECOED } from 'utils/Constants'
import { InstitutionServices } from 'utils/InstitutionServices'
import { useState } from 'react';
import DocPreview from "assets/images/doc-preview.png"
import CommonLoader from 'common/CommonLoader';
import { showErrorMessage, showSuccessMessage } from 'common/AlertContainer'

const ManageWidgets = (props) => {
    const { eThemeDetails, institution, setEThemeDetails, setRefreshFlag, setModalIndex, toggle } = props
    const [loading, setLoading] = useState(false);
    const [uThemeDetails, setUThemeDetails] = useState(eThemeDetails);
    const [imgPathSrc, setImgPathSrc] = useState('');
    const [imgType, setImgType] = useState('');
    const [selectedWidget, setSelectedWidget] = useState(null);

    const previewAds = (adsDetails) => {
        setSelectedWidget(adsDetails);
        setImgPathSrc(adsDetails.adspath);
        setImgType(adsDetails.advtype);
    }

    const removeAds = async (adsid) => {
        const { isConfirmed } = await Swal.fire({
            title: ' ',
            text: "Are you sure you want to remove this Advertisement ?",
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes',
        });

        if (isConfirmed) {
            setLoading(true);
            MedialService.deleteMedia(adsid)
                .then((response) => {
                    const { status } = response;
                    if (status === 204) {
                        const updatedDraggables = eThemeDetails.draggables.filter(draggable => draggable.imgid !== adsid);
                        const updatedThemeDetails = { ...eThemeDetails, draggables: updatedDraggables };
                        InstitutionServices.updateDisplayPreferences(institution?.guid, updatedThemeDetails)
                            .then((saveresponse) => {
                                const { status, data } = saveresponse;
                                if (status === 200) {
                                    setUThemeDetails(data);
                                    setEThemeDetails(data);
                                    setRefreshFlag(true);
                                    showSuccessMessage("Advertisement removed successfully");
                                    setModalIndex(Math.random())
                                }
                                else {
                                    showErrorMessage(FAILTOSAVERECOED);
                                    // showErrorMessage("Something went wrong, Please try again later");
                                }
                            })
                    } else {
                        showErrorMessage(FAILED_TO_DELETE_DATA);
                    }
                })

            setImgPathSrc('');
            setLoading(false);
        }
    }

    return (
        <>
            <div className="container-fluid nex-manage-preview">
                <div className="row">
                    {/* <!-- First Column with Scroll --> */}
                    <div className="col-md-12 m-0 p-0">
                        <div className="scrollable-content m-0 p-0 content-box">
                            {uThemeDetails && uThemeDetails?.draggables &&
                                uThemeDetails?.draggables?.length > 0 &&
                                uThemeDetails?.draggables.map((widgets, index) => (
                                    <Card className={`m-1 ${selectedWidget === widgets ? 'selected' : ''}`}>
                                        <CardBody className={`py-3`}>
                                            <Row key={index} className='align-items-center'>
                                                {/* <Col className='w-25 text-center pt-1'>{index + 1}</Col> */}
                                                <Col className='w-25 text-center pt-1' onClick={() => previewAds(widgets)} style={{ cursor: "pointer" }}>
                                                    <img src={DocPreview} width="30px" alt='ads_preview' />
                                                </Col>
                                                <Col lg={9} sm={9} className='w-50 pt-1 fsize' onClick={() => previewAds(widgets)} style={{ cursor: "pointer" }}>{widgets.name}</Col>
                                                <Col lg={1} sm={1} className='p-0 text-center'>
                                                    <Button
                                                        color="link-danger"
                                                        className="visible-hover py-0 text-danger pl-1"
                                                        onClick={() => removeAds(widgets?.imgid)}
                                                    >
                                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="16.2266" cy="16" r="15.75" fill="#FFEAEF" />
                                                            <path d="M11.3984 13.7734L12.2586 20.1323C12.426 21.3702 12.5097 21.9892 12.9337 22.3597C13.3577 22.7302 13.9823 22.7302 15.2315 22.7302H18.4692C19.7184 22.7302 20.343 22.7302 20.767 22.3597C21.191 21.9892 21.2747 21.3702 21.4421 20.1323L22.3023 13.7734" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M14.5156 11.0475V11.0475C14.5156 10.2672 14.5156 9.87708 14.6572 9.57473C14.8061 9.25693 15.0616 9.00138 15.3794 8.85254C15.6818 8.71094 16.0719 8.71094 16.8522 8.71094V8.71094C17.6324 8.71094 18.0226 8.71094 18.3249 8.85254C18.6427 9.00138 18.8983 9.25693 19.0471 9.57473C19.1887 9.87708 19.1887 10.2672 19.1887 11.0475V11.0475" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M22.3023 11.0547L11.3984 11.0547" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M14.8906 14.1719L15.28 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M18.7957 14.1719L18.4062 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                ))
                            }
                        </div>
                    </div>
                    <div className="col-md-12 view-box mt-3">
                        <div className="pl-1 border d-flex justify-content-center align-items-center nex-manage-preview-col rounded" style={{ position: 'relative', overflow: 'hidden' }}>
                            {!uThemeDetails?.draggables?.length > 0 ? (
                                <p className='py-5 view-box'>No Ads</p>
                            ) : imgPathSrc === '' ? (
                                <p className='py-5 view-box'>Ads Preview</p>
                            ) : (
                                <img
                                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/micro_site_${institution?.guid}/${imgPathSrc.replace(/\s+/g, '_')}`}
                                    className={`rounded ${imgType === 'Portrait' ? 'portrait' : 'landscape'}`}
                                    alt='Ads preview'
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManageWidgets